import MuCv from './muCv'

const muCv = {
  install: function (Vue) {
    Vue.component('MuCv', MuCv)
  }
}
export default muCv



// WEBPACK FOOTER //
// ./src/components/muCvIndex.js